import { useEffect, useState } from 'react';

const useVisibilityChangeListener = () => {
  const [isTabInFocus, setIsTabInFocus] = useState(!document.hidden);
  useEffect(() => {
    const onVisibilityChange = () => {
      setIsTabInFocus(!document.hidden);
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, []);
  return isTabInFocus;
};

export default useVisibilityChangeListener;
